/**
 * Re-exports the server-side cookieSerializer so that client and server share a
 * single source of truth for cookie encoding/decoding logic and settings.
 *
 * The server-side module contains no SFCC-specific imports (no dw/* dependencies),
 * so webpack can bundle it for the browser without any special configuration.
 *
 * To change settings (e.g. sfccCompat), edit only:
 *   scripts/util/cookieSerializer.js
 */
module.exports = require('../../../../scripts/util/cookieSerializer');
